export default {
	sessionId: null,
	subscriptionError: null,
	subscriptionReady: false,
	vinImportEvent: null,
	createFromDraftEvent: null,
	isCreateFromDraftModalOpen: false
}
